"use client"
import AboutUs from '@/app/components/AboutUs'
import HomeBanner from '@/app/components/HomeBanner'
import OurClients from '@/app/components/OurClients'
import ServicesCardsContainer from '@/app/components/ServicesCardsContainer'
import Testimonial from '@/app/components/Testimonial'
import WhatWeOffer from '@/app/components/WhatWeOffer'
import WorkProcess from '@/app/components/WorkProcess'
import {  flatlane, syrianLancer, } from '@/assets/imgs'
import { useTranslations } from 'next-intl'


const Landing = () => {
  const t=useTranslations()

const clientsData = [

  {
    logo: flatlane,
    content:  t("clients.flatlane.contentEasyKey"),
    name: "Flatlane"
  },
  {
    logo: syrianLancer,
    content: t("clients.syrianLancer.contentEasyKey"),
    name: "SyrianLancer"
  },
  
]

  return (
    <main>
      <section className='relative z-20'>
        <div className='absolute top-0 -z-10 h-1/3 w-full bg-landing bg-cover bg-fixed bg-center md:h-full md:[clip-path:ellipse(100%_80%_at_50%_0%)]' />
        <HomeBanner />
        <ServicesCardsContainer className='px-6 pb-14 sm:px-14 md:px-16' />
      </section>
      <section>
        <AboutUs className='px-6 py-14 sm:px-14 md:px-16' />
        <WhatWeOffer className='bg-lightGrey py-12' />
        <WorkProcess className='px-6 py-14 sm:px-14 md:px-16 md:pt-28' />
        <OurClients clients={clientsData} className="px-6 py-14 sm:px-14 md:px-16" />
        <div className='bg-primary text-white  px-6 py-14 sm:px-14 md:px-16 bg-testimonial bg-cover bg-no-repeat'>
          <Testimonial  />
        </div>
      </section>
    </main>
  )
}

export default Landing
